import React from 'react';
import themePrimary from '../../../styles/themePrimary';
import clsx from 'clsx';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { IconButton as MatIconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ElementDimensions } from '../../../styles/ElementDimensions';
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';
import { Skin } from '../../../models/common/Skin';

const useStyles = makeStyles({
    root: {

    },
    button: {
        backgroundColor: props => (props as Skin).primary_main_color,
        color: themePrimary.palette.primary.contrastText,
        textAlign: 'center',
        borderRadius: '23px',
        height: '46px',
        width: '60px',       
    },
    buttonHidden: {
        backgroundColor: props => (props as Skin).primary_main_color,
        color: themePrimary.palette.primary.contrastText,
        textAlign: 'center',
        borderRadius: '23px',
        height: '46px',
        width: '60px',  
        visibility: 'hidden',     
    },
    icon: {
        height: '30px',
        width: '30px',
    },
});

const BackButtonInternal = withStyles((themePrimary) => ({
  root: {
    borderRadius: '50%',
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,

  },
  label: {
      fontSize: '1rem',
  }
}))(MatIconButton);

export type BackButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface BackButtonProps {
    disabled: boolean,
    hidden: boolean,
    onClickHandler: BackButtonClickHandler
}

export default function BackButton(props: BackButtonProps) {
    const { disabled, hidden, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
        <div className={classes.root}>
            <div className={clsx({
                    [classes.button]: !hidden,
                    [classes.buttonHidden]: hidden,
                })}>
                <BackButtonInternal
                    disabled={disabled}
                    onClick={onClickHandler}
                    className={clsx({
                        [classes.button]: !hidden,
                        [classes.buttonHidden]: hidden,
                    })}>
                    <div>
                        <ChevronLeftIcon className={classes.icon}/>
                    </div>
                </BackButtonInternal>
            </div>
        </div>
    );
}